import React from "react";
import { Link } from "react-router-dom";
import { sectionEightLogos } from "../../data";
import {
  SectionNine,
  SectionNineTop,
  SectionNineTopInner,
  SectionNineTitle,
  SectionNineLogos,
  SectionNineLogo,
  SectionNineBottom,
  SectionNineBottomInner,
  SectionNineResults,
  SectionNineResultsTitle,
  StarsRow,
  StarsImage,
  SectionNineActions,
  SectionNineCta,
  SectionNineBrand,
  SectionNineLegal,
  SectionNineLegalButton,
  FapescLogo,
  SectionNineSocial,
  SectionNineMobileSocial,
  SectionNineSocialTitle,
  SocialStack,
  SocialIconLink,
  SocialIconImage,
  SocialIconImageYoutube,
  SectionNineLogosTrack,
  SectionNineLogosGroup,
  SectionNineLogoItem,
} from "./styles";

const LOGIN_URL = "https://www.trataz.com.br/login";

export default function SectionNineComponent({ onOpenPrivacyPolicy }) {
  return (
    <SectionNine>
      <SectionNineTop>
        <SectionNineTopInner>
          <SectionNineTitle>EMPRESAS QUE NOS RELACIONAMOS</SectionNineTitle>

          <SectionNineLogos>
            <SectionNineLogosTrack>
              <SectionNineLogosGroup>
                {sectionEightLogos.map((src, index) => (
                  <SectionNineLogoItem key={src}>
                    <SectionNineLogo
                      src={src}
                      alt={`Parceiro Trataz ${index + 1}`}
                      loading="lazy"
                      decoding="async"
                    />
                  </SectionNineLogoItem>
                ))}
              </SectionNineLogosGroup>

              <SectionNineLogosGroup aria-hidden="true">
                {sectionEightLogos.map((src) => (
                  <SectionNineLogoItem key={`${src}-loop`}>
                    <SectionNineLogo
                      src={src}
                      alt=""
                      loading="lazy"
                      decoding="async"
                    />
                  </SectionNineLogoItem>
                ))}
              </SectionNineLogosGroup>
            </SectionNineLogosTrack>
          </SectionNineLogos>
        </SectionNineTopInner>
      </SectionNineTop>

      <SectionNineBottom>
        <SectionNineBottomInner>
          <SectionNineResults>
            <SectionNineResultsTitle>
              RESULTADOS
              <br />
              COMPROVADOS
            </SectionNineResultsTitle>

            <StarsRow>
              <StarsImage
                src="/novas-imagens/section-eight/stars.png"
                alt="Avaliação cinco estrelas"
              />
            </StarsRow>

            <SectionNineMobileSocial>
              <SectionNineSocialTitle>SIGA-NOS</SectionNineSocialTitle>

              <SocialStack>
                <SocialIconLink
                  href="https://www.instagram.com"
                  aria-label="Instagram"
                >
                  <SocialIconImage
                    src="/novas-imagens/section-eight/instagram-icon.png"
                    alt="Instagram"
                  />
                </SocialIconLink>
                <SocialIconLink
                  href="https://www.youtube.com"
                  aria-label="YouTube"
                >
                  <SocialIconImageYoutube
                    src="/novas-imagens/section-eight/youtube-icon.png"
                    alt="YouTube"
                  />
                </SocialIconLink>
              </SocialStack>
            </SectionNineMobileSocial>

            <SectionNineActions>
              <SectionNineCta
                as={Link}
                to={LOGIN_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                TESTAR GRATUITAMENTE
              </SectionNineCta>
              <SectionNineCta
                as={Link}
                to="https://wa.me/5547996912977"
                target="_blank"
                rel="noopener noreferrer"
              >
                VAMOS CONVERSAR?
              </SectionNineCta>
            </SectionNineActions>

            <SectionNineBrand
              src="/novas-imagens/section-eight/logo.png"
              alt="Trataz"
            />
            <SectionNineLegal>
              <SectionNineLegalButton
                type="button"
                onClick={onOpenPrivacyPolicy}
              >
                Política de Privacidade
              </SectionNineLegalButton>
            </SectionNineLegal>
            <FapescLogo
              src="/novas-imagens/logo-fapesc-branco.png"
              alt="FAPESC"
              loading="lazy"
              decoding="async"
            />
          </SectionNineResults>

          <SectionNineSocial>
            <SectionNineSocialTitle>SIGA-NOS</SectionNineSocialTitle>

            <SocialStack>
              <SocialIconLink
                href="https://www.instagram.com"
                aria-label="Instagram"
              >
                <SocialIconImage
                  src="/novas-imagens/section-eight/instagram-icon.png"
                  alt="Instagram"
                />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.youtube.com"
                aria-label="YouTube"
              >
                <SocialIconImageYoutube
                  src="/novas-imagens/section-eight/youtube-icon.png"
                  alt="YouTube"
                />
              </SocialIconLink>
            </SocialStack>
          </SectionNineSocial>

          <div />
        </SectionNineBottomInner>
      </SectionNineBottom>
    </SectionNine>
  );
}
